<script context="module">
  export function callToggleTos () {

    if(tglTos !== null) tglTos()
  }
  let tglTos = null
</script>

<script>
  import {
    Button,
    Spinner,
    Container,
    Row,
    Col,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader
  } from '@sveltestrap/sveltestrap'

  import { createEventDispatcher } from 'svelte'
  import { _, locale } from 'svelte-i18n'
  import { marked } from 'marked'

  let open = false
  const size = 'lg'

  const dispatch = createEventDispatcher()

  const toggle = () => {
    open = !open
  }

  async function getTos(loc) {
    loc = 'en'
    const url = '/markdown/tos/en.md'
    const res = await fetch(url)
    if (res.ok) {
      const mdText = res.text()
      return mdText
    } else {
      throw new Error($_('error.unknown'))
    }
  }
  let tosMd = getTos($locale)
  tglTos = toggle
</script>

<Modal isOpen={open} {toggle} {size}>
    <ModalHeader {toggle}>{$_('tos.title')}</ModalHeader>
    <ModalBody>
      {#await tosMd}
      <Container class="m-5">
        <Row>
          <Col class="col-5">
            <Spinner color="primary" class="align-middle" type="grow" />
            &nbsp;Loading Terms of Service...
          </Col>
        </Row>
      </Container>
      {:then tos}
        {@html marked(tos)}
      {:catch error}
      	<p style="color: red">{error.message}</p>
      {/await}
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" on:click={toggle}>{$_('tos.button')}</Button>
    </ModalFooter>
  </Modal>
